import React from 'react';
import { Card } from '../SubscriptionAppCard';
import { contactSummaryLines } from '../../data/mockContactOverview';

// A few plain-English lines to read before picking up the phone
export function ContactSummaryCard() {
  return <Card padding="none" data-id="element-1561" data-mp="26pwvziudmhcr">
      <div className="px-6 py-4 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-1562" data-mp="26olq9dhdezj0">
        <h3 className="text-[16px] font-semibold text-[#0F172A]" data-id="element-1563" data-mp="2bjhqv20oav7q">Summary</h3>
      </div>
      <ul className="px-6 py-4 bg-white rounded-b-lg space-y-2" data-id="element-1564" data-mp="2fiqk85rswr2r">
        {contactSummaryLines.map(line => <li key={line} className="flex items-start gap-2.5 text-sm text-[#475569]" data-id="element-1565" data-mp="2kg8pnm6m0o60">
            <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9] flex-shrink-0 mt-[7px]" aria-hidden="true" data-id="element-1566" data-mp="2phplh3a8lkfq" />
            {line}
          </li>)}
      </ul>
    </Card>;
}